export const getClaimStatusAndRecoveryApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `analytics/contract_analytics/claim-status-recovery${queryString ? `?${queryString}` : ''}`;
}
export const getClaimApvTurnAroundApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `analytics/contract_analytics/claim-approval-turnaround${queryString ? `?${queryString}` : ''}`;
}
export const getPlannedCompletedSVApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `analytics/contract_analytics/planned-completed-shop-visits${queryString ? `?${queryString}` : ''}`;
}
export const getCashflowWaterfallApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `analytics/contract_analytics/cashflow-waterfall${queryString ? `?${queryString}` : ''}`;
}
export const getCashflowForecastApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `analytics/contract_analytics/cashflow-forecast${queryString ? `?${queryString}` : ''}`;
}
export const getCurrencyApi = () => {
    return `/console/currency/`;
}
export const getMonthlyUtilizationApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/analytics/module/monthly-utilization-trend${queryString ? `?${queryString}` : ''}`;
}
export const getUtilizationAssetsApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}
export const getMaintenanceEventApi = (assetType, assetId) => {
    return `config/maintenance-checks/${assetType}/${assetId}/`;
}
export const getAverageUtilizationApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/analytics/module/average-utilization-by-contract-component${queryString ? `?${queryString}` : ''}`;
}
export const getComponentUtilizationTrendsApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/analytics/module/component-utilization-trends${queryString ? `?${queryString}` : ''}`;
}
export const getInvPaymentTrendsApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/analytics/module/invoice-payment-trends${queryString ? `?${queryString}` : ''}`;
}

export const getInvReceivablesApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/receivables-ageing${queryString ? `?${queryString}` : ''}`;
}

export const getPaymentTimelinessApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/payment-timeliness${queryString ? `?${queryString}` : ''}`;
}

export const getAmendmentHistoryApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/amendment-history${queryString ? `?${queryString}` : ''}`;
}
export const getFundMovementWaterfallApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/fund-movement-waterfall${queryString ? `?${queryString}` : ''}`;
}

export const getOpenDeliveryExceptionApi = (params = {}, query = {}) => {
    const {leaseSlug} = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/open-redelivery-exceptions${queryString ? `?${queryString}` : ''}`;
}

export const getContractActionCentreApi = (params = {}, query = {}) => {
    const {leaseSlug} = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/contract-action-centre${queryString ? `?${queryString}` : ''}`;
}

export const getUpcomingCriticalDatesApi = (params = {}, query = {}) => {
    const {leaseSlug} = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/upcoming-critical-dates${queryString ? `?${queryString}` : ''}`;
}

export const contractDataComplitnessApi = (params = {}, query = {}) => {
    const {leaseSlug} = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/contract-data-completeness${queryString ? `?${queryString}` : ''}`;
}

export const contractHealthOverviewApi = (params = {}, query = {}) => {
    const {leaseSlug} = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/contract-health-overview${queryString ? `?${queryString}` : ''}`;
}
export const getMRFundBalanceByEventTypeApi = (params = {}, query = {}) => {
    const { leaseSlug } = params;
    const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/contract-analytics/mr-fund-balance-by-event-type${queryString ? `?${queryString}` : ''}`;
}
